import classNames from 'classnames';
import type React from 'react';
import { Link } from 'react-router-dom';

import { FormattedTag } from 'src/components/formatted-tag/formatted-tag';

interface SidebarLinkProps {
  id: string;
  labelId?: string;
  icon: React.ReactElement;
  isActive: boolean;
  to: string;
}

export const SidebarLink: React.FC<SidebarLinkProps> = ({ id, labelId, icon, isActive, to }) => (
  <Link to={to}>
    <div
      className={classNames(
        'flex items-center pl-16 pr-4 py-9 rounded-lg cursor-pointer ease duration-100 hover:opacity-100',
        {
          'opacity-70': !isActive,
          'bg-gray-14': isActive,
        },
      )}
    >
      <div>{icon}</div>

      <FormattedTag id={id} className={classNames('ml-12 text-[14px]/[22px]', { 'font-medium': isActive })} />

      {labelId && (
        <FormattedTag
          id={labelId}
          className="ml-4 text-[8px]/[20px] font-semibold rounded-[3px] border border-gray-8 px-4 shrink-0 text-gray-8"
        />
      )}
    </div>
  </Link>
);
